// Loads what the modal needs beyond the list row: the full execution record for
// the payload accordion, and — for a cached response — the execution the cache
// was populated from, whose timestamps drive the Observer link.

import { useEffect, useState } from 'react';

import StepFunctionExecutionsApi from '../../api/step_function_executions';

export default function useExecutionDetail({ visibility, log }) {
  const [detailLog, setDetailLog] = useState(null);
  const [detailError, setDetailError] = useState(false);
  const [parentLog, setParentLog] = useState(null);

  useEffect(() => {
    if (!visibility || !log?.id) {
      setDetailLog(null);
      setDetailError(false);
      return undefined;
    }

    let cancelled = false;
    setDetailLog(null);
    setDetailError(false);

    const fetchDetail = async () => {
      try {
        const { data } =
          await StepFunctionExecutionsApi.fetchStepFunctionExecutionById(
            log.id,
          );
        if (cancelled) return;
        if (data?.attributes) {
          setDetailLog(data.attributes);
        } else {
          setDetailError(true);
        }
      } catch {
        if (!cancelled) setDetailError(true);
      }
    };

    fetchDetail();

    return () => {
      cancelled = true;
    };
  }, [visibility, log?.id]);

  useEffect(() => {
    if (
      visibility &&
      log?.response_from_cache &&
      log?.parent_x_decisiv_trace_id
    ) {
      let cancelled = false;

      const fetchParentLog = async () => {
        try {
          const { data } =
            await StepFunctionExecutionsApi.fetchStepFunctionExecutionsByTraceId(
              log.parent_x_decisiv_trace_id,
            );
          if (cancelled) return;
          setParentLog(data && data.length > 0 ? data[0].attributes : null);
        } catch {
          if (!cancelled) setParentLog(null);
        }
      };

      fetchParentLog();
      return () => {
        cancelled = true;
      };
    }

    setParentLog((prev) => (prev !== null ? null : prev));
    return undefined;
  }, [visibility, log?.response_from_cache, log?.parent_x_decisiv_trace_id]);

  return { detailLog, detailError, parentLog };
}
